import { mapGetters, mapActions } from 'vuex'

export const Computed = {
  ...mapGetters('configuration', ['cachedConfigurations']),
}

export const Methods = mapActions('configuration', [
  'fetchConfigurations',
  'updateConfiguration',
])
